/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DateTime } from 'luxon';

export const dateToSchedule = ({
  d,
  date,
  h,
  m,
  mon,
  wd,
}: {
  date: Date | string;
  mon?: boolean;
  h?: boolean;
  d?: boolean;
  m?: boolean;
  wd?: boolean;
}): string => {
  const instance = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date);
  return [
    m ? instance.toFormat('mm') : '*',
    h ? instance.toFormat('HH') : '*',
    d ? instance.toFormat('dd') : '*',
    mon ? instance.toFormat('MM') : '*',
    wd ? instance.weekday % 7 : '*', // Luxon: 1=Monday, 7=Sunday; moment: 0=Sunday, 6=Saturday
  ].join(' ');
};
